var map = {
	"./0vix.webp": 69120,
	"./aave.webp": 85984,
	"./apeswap.webp": 35347,
	"./aurigami.webp": 13664,
	"./bastion.webp": 45713,
	"./benqi.webp": 11359,
	"./compound.webp": 86485,
	"./inverse.webp": 80326,
	"./iron-bank.webp": 4164,
	"./maker.webp": 99062,
	"./mim.webp": 950,
	"./moonwell.webp": 42384,
	"./rari-capital.webp": 5701,
	"./rikki.webp": 3516,
	"./tectonic.webp": 4036,
	"./trader-joe.webp": 69226,
	"./venus.webp": 40508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20964;